import { render, staticRenderFns } from "./agentRegister.vue?vue&type=template&id=6ed63d4a&scoped=true&"
import script from "./agentRegister.vue?vue&type=script&lang=js&"
export * from "./agentRegister.vue?vue&type=script&lang=js&"
import style0 from "./agentRegister.vue?vue&type=style&index=0&id=6ed63d4a&scoped=true&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./agentRegister.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed63d4a",
  null
  
)

export default component.exports